module.exports = __webpack_public_path__ + "img/ic_disconnected.8e037852.svg";